<h1 class="title-modal-add-user" mat-dialog-title>
  <strong>DataBase Configuration</strong>
  <mat-icon (click)="onClose(false)">close</mat-icon>
</h1>
<mat-divider class="divider"></mat-divider>
<form [formGroup]="connectionForm" (ngSubmit)="onSubmit()">
  <mat-form-field fxFill appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput id="name" formControlName="name" type="text" placeholder="Enter the name" />
  </mat-form-field>
  <mat-form-field fxFill appearance="fill">
    <mat-label>URL</mat-label>
    <input matInput id="url" formControlName="url" type="text" placeholder="Enter the url" />
  </mat-form-field>

  <div class="connection-data">
    <mat-form-field appearance="fill">
      <mat-label>Username</mat-label>
      <input matInput id="username" formControlName="username" type="text" placeholder="Enter the username" />
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Password</mat-label>
      <div class="password-container">
        <input [type]="hide ? 'password' : 'text'" matInput id="password" formControlName="password" placeholder="Enter the password" />
        <mat-icon style="cursor: pointer" (click)="hide = !hide">{{ !hide ? 'visibility_off' : 'visibility' }}</mat-icon>
      </div>
    </mat-form-field>
  </div>
  <mat-divider class="divider"></mat-divider>

  <div mat-dialog-actions class="btn-container">
    @if (data !== null) {
    <button type="submit" mat-raised-button color="warn">Update</button>
    } @else {
    <button type="submit" mat-raised-button color="primary" [disabled]="!connectionForm.valid">Submit</button>
    }
  </div>
</form>
